import decode from "jwt-decode";
import { NavigationGuard } from "vue-router";

import { NativeApp } from "@/plugins/native-app";

const TOKEN_KEY = "vvs_token";

// The JWT Token is stored in session storage for Web users (so closing the windowm logs them out) and local storage
// for Mobile users (so they stay logged in after closing and reopening the app). Try to load it from both storages
// since there's no way to now if the user is Mobile or Web at this point.
let _token = localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);

export function setToken(token: string, nativeApp: NativeApp) {
  // Save the JWT Token to the correct storage based on the type of user
  const storage = nativeApp.isMobile ? localStorage : sessionStorage;
  storage.setItem(TOKEN_KEY, token);

  _token = token;
}

export function clearToken() {
  // When logging out, just remove the token from both storages (no need to check which is being used)
  localStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(TOKEN_KEY);

  _token = null;
}

export function getToken(): string | null {
  return _token;
}

export function isLoggedIn() {
  return !!_token;
}

export function requireAuth(...permissions: string[]) {
  const guard: NavigationGuard<Vue> = function(to, from, next): any {
    if (!isLoggedIn()) {
      next({
        path: "/sign-in",
        query: { redirect: to.fullPath }
      });
      return;
    }
    // check permissions
    const token = decode<any>(getToken() || "");

    if (permissions.every(p => token.user.claims.indexOf(p) >= 0)) {
      // success
      next();
    } else {
      next("/unauthorized");
    }
  };

  return guard;
}
